import React, { useState, useEffect } from "react";
import { Field } from "formik";
import { Stepper } from "react-form-stepper";
import style from "./UploadDocuments.module.css";
import BankDeatils from "../BankDetails/BankDetails";
import Dropdown from "../../../utils/Dropdown.json";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import {
  checkIfPermitted,
  Permissions,
} from "../../../services/RolePermissionService";
import { object } from "yup";

const UploadDocuments = (props) => {
  const [isScreenLoaded, setIsScreenLoaded] = useState(false);
  const [imageErr, setImageError] = useState("");
  const [inputList, setInputList] = useState([]);

  const [max_upload, setMaxUpload] = useState(
    localStorage.getItem("SETTING_INFO") &&
      JSON.parse(localStorage.getItem("SETTING_INFO")).max_upload
  );

  useEffect(() => {
    // if (props.values.isEditMode) {
    if (props.values.uploadDocs.length != 0) {
     // console.log("use effect", props.values.uploadDocs);
      setInputList(props.values.uploadDocs);
    }
    // }
  }, [props.values.isEditMode]);

  // Getting role of user
  let userData = JSON.parse(localStorage.getItem("USER_INFO"));

  // handle input change
  const handleInputChangeFile = (e, index, setFieldValue) => {
    const { name, files } = e.target;

    if (files && files[0]) {
      var FileSize = files && files[0].size / 1024 / 1024; // in MB
      console.log("FileSize in MB ", FileSize);
      if (
        /\.(jpe?g|png|svg|pdf|txt)$/i.test(files && files[0].name) === false
      ) {
        setImageError("This type of file extension is not allowed");
        let uploadflag = true;
      } else {
        if (FileSize > 2.0) {
          setImageError("Please upload file less than 2MB!");
        } else {
          let uploadflag = false;
          setImageError("");

          const list = [...inputList];
          list[index][name] = files[0];
          list[index].isNewUpload = true;
          list[index].delete = 0;
          setInputList(list);
          setFieldValue("uploadDocs", [...list]);
        }
      }
    }
  };

  const handleInputChange = (e, index, setFieldValue) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    setFieldValue("uploadDocs", list);
  };
  // handle click event of the Remove button
  const handleRemoveClick = (index, setFieldValue) => {
    setImageError("");
    const list = [...inputList];
    if (list[index].isNewUpload) {
      list.splice(index, 1);
    } else {
      list[index].delete = 1;
    }
    setInputList(list);
    setFieldValue("uploadDocs", list);
  };

  const goBackStep1 = () => {
    props.navigateBackStep1();
  };

  const goBackStep2 = () => {
    props.navigateBackStep2();
  };

  const goBack = () => {
    props.navigateBack();
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setImageError("");
    setInputList([
      ...inputList,
      { selectedFile: "", description: "", isNewUpload: true, delete: 0 },
    ]);
  };

  // Getting role options from dropdown file
  const roleOptions = Dropdown.role
    .filter((opt) => opt.role_name !== "Super Administrator")
    .map((opt, index) => (
      <option key={index} value={opt.role_id}>
        {opt.role_name}
      </option>
    ));

  setTimeout(() => {
    setIsScreenLoaded(true);
  }, 500);

  if (!isScreenLoaded) {
    return (
      <div className="dashboard-loader">
        <img src={ttmLoader} alt="loader" className="loader-image" />
      </div>
    );
  }

  return (
    <div className={style.uloadDocMainWrapper}>
      <div className={style.headingWrapper}>
        <h2>Step 4 : Contact Creation</h2>
        <p> Upload any documentation that forms a part of the Contact creation. 
          This may include Organisation Registration Documents, Certificates of Compliance, SARS Registration Documents etc.
        </p>
        <hr />
      </div>
      <div className="row">
        <div className="col-md-10 col-xl-6">
          <div className="custom-stepper">
            <div className={style.stepperWrapper}>
              <ul>
                <li>
                  <h3 onClick={goBackStep1}>1</h3>
                </li>
                <li onClick={goBackStep2}>
                  <h3>2</h3>
                </li>
                <li>
                  <h3 onClick={goBack}>3</h3>
                </li>
                <li>
                  <h3 className="active">4</h3>
                </li>
              </ul>
            </div>
            {/* <div className="custom-stepper">
              <div className={style.stepperWrapper}>
                <Stepper
                  steps={[
                    { label: "" },
                    { label: "" },
                    { label: "" },
                    { label: "" },
                  ]}
                  activeStep={0}
                  styleConfig={{
                    inactiveBgColor: "#fff",
                    activeBgColor: "#00467F",
                    inactiveTextColor: "#00467F",
                    activeTextColor: "#fff",
                    completedBgColor: "#fff",
                    completedTextColor: "#00467F",
                  }}
                  connectorStyleConfig={{
                    disabledColor: "#00467F33 ",
                    size: 2,
                  }}
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className={`form-controls-wrapper ${style.uploadDocFormWrapper}`}>
          {/* Hide if user role is super admin*/}
       {/* <div className={style.relatedPartyRoleWrapper}>
           {checkIfPermitted(Permissions.CREATE_SYSTEM_USERS) && (
            <div>
              <h4>System access</h4>
              <div className="row form-group">
                <div className="col-md-6 col-lg-6">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="systemUserCheck"
                      name="systemUserCheck"
                      checked={props.values.systemUserCheck}
                      onChange={props.handleChange}
                      className={
                        "custom-control-input" +
                        (props.errors.systemUserCheck &&
                        props.touched.systemUserCheck
                          ? " is-invalid"
                          : "")
                      }
                      disabled={props.values.isEditMode ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="systemUserCheck"
                    >
                      Allow system user
                    </label>
                  </div>
                  {props.errors.systemUserCheck &&
                  props.touched.systemUserCheck ? (
                    <div className={style.errMsg}>
                      {props.errors.systemUserCheck}
                    </div>
                  ) : null}
                </div>
              </div>

              {props.values.systemUserCheck === true && (
                <div className="row form-group">
                  <div className="col-md-6 col-lg-4">
                    <label>
                      Choose the system role for the Contact
                      <span className="mandatory">*</span>
                    </label>
                    <Field
                      as="select"
                      name="systemRoleParty"
                      onChange={props.handleChange}
                      className={
                        `form-control systemCustomRole ${style.systemRoleOption}` +
                        (props.errors.systemRoleParty &&
                        props.touched.systemRoleParty &&
                        props.values.systemUserCheck === true
                          ? "is-invalid"
                          : "")
                      }
                    >
                      <option value="">Select a system role</option>
                      {roleOptions}
                    </Field>
                    {props.errors.systemRoleParty &&
                    props.touched.systemRoleParty &&
                    props.values.systemUserCheck === true ? (
                      <div className={style.errMsg}>
                        {props.errors.systemRoleParty}
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
            </div>
          )} 
        </div>*/}

        {max_upload !== 0 && (
          <div>
            <div className="row">
              <div className="col-md-12">
                <h4>Upload Documents </h4>
                <p className={style.extensionAllowed}>
                  <small>You can upload maximum {max_upload} documents.</small>
                  <br />
                  <small>
                    Allowed extensions are .txt, .pdf, .png, .jpeg, .svg and max
                    limit size is 2MB
                  </small>
                </p>
              </div>
            </div>
            
            <div className="order-5 order-sm-5 order-md-5 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                    {inputList.length === 0 && (
                        <button
                          onClick={handleAddClick}
                          className={`${style.addBtn} ${style.singleAddBtn}`}
                        >
                          <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                          Add
                        </button>
                      )}
                  </div>
            {inputList &&
              inputList.map((x, i) => {
                return(
                  <div className="box" key={i}>
                    <div className={`row ${style.mobileUploadDeocWrapper}`}>
                      <div className="col-8 col-sm-6 col-md-3 col-lg-1.5 col-xl-4">
                      {(!x.selectedFile || (typeof x.selectedFile == object && !x.selectedFile.name)) && (
                        <div className="form-group">
                          <div className={style.uploadBtnWrapper}>
                            <button type="button" className={style.uploadBtn}>
                              <i
                                className="fa fa-upload mr-2"
                                aria-hidden="true"
                              ></i>{" "}
                              Upload
                              <Field
                              type="file"
                              name="selectedFile"
                              onChange={(e, setFieldValue) => {
                                handleInputChangeFile(
                                  e,
                                  i,
                                  props.setFieldValue
                                );
                              }}
                              title={
                                x.selectedFile
                                  ? x.selectedFile.name
                                  : x.selectedFile
                              }
                            />
                            </button>
                          </div>
                        </div>)}
                        <div className={`form-group ${style.uploadedText}`}>
                          {x.isNewUpload && x.selectedFile
                            ? x.selectedFile.name
                            : x.selectedFile}
                        </div>
                      </div>
                      {/* <div className="order-3 order-sm-3 order-md-2 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                       
                      </div> */}
                      <div className="order-4 order-sm-4 order-md-3 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                        <div className="form-group">
                          <Field
                            className={`form-control ${style.description}`}
                            name="description"
                            placeholder="Description"
                            value={x.description}
                            onChange={(e, setFieldValue) =>
                              handleInputChange(e, i, props.setFieldValue)
                            }
                          />
                        </div>
                      </div>
                      <div
                        className={`oder-2 oder-sm-2 order-md-4 col-4 col-sm-6 col-md-1 col-lg-1 col-xl-1 ${style.pullRightIcon}`}
                      >
                        {inputList.length > 0 && (
                          <i
                            className={`fa fa-times ${style.deleteIcon}`}
                            aria-hidden="true"
                            onClick={(setFieldValue) =>
                              handleRemoveClick(i, props.setFieldValue)
                            }
                          ></i>
                        )}
                      </div>
                      <div className="order-5 order-sm-5 order-md-5 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                        {inputList.length - 1 === i &&
                          inputList.length < max_upload && (
                            <button
                              onClick={handleAddClick}
                              className={style.addBtn}
                            >
                              <i
                                className="fa fa-plus mr-2"
                                aria-hidden="true"
                              ></i>
                              Add
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                );
              })}
            <span className="error">{imageErr ? imageErr : ""}</span>
          </div>
        )}

        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
        <hr className={style.formBottomLine} />

        <div
          className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
        >
          <button
            type="button"
            className="btn form-primary-btn mb-3"
            onClick={props.navigateBack}
          >
            Back
          </button>
          <button type="submit" className="btn form-primary-btn mb-3">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadDocuments;
